







































import { Component, Prop, Vue } from "vue-property-decorator";
import { BaseComponent } from "@/app/BaseComponent";

export const COMPONENT_NAME = "ClockIcon";

@Component({
    name: COMPONENT_NAME,
})
export default class ClockIcon extends BaseComponent {

}
